import MetahubJS from 'metahubjs'
import { Api } from 'eosjs'
import type { EosAccount, EosAction, EosConfig, TransactionResult, WalletAdapter } from '@/types'

export class MetahubWallet implements WalletAdapter {
  private provider: any = MetahubJS
  private eos: any = null
  private accounts: EosAccount[] = []

  async connect(config: EosConfig, rpc: unknown): Promise<EosAccount[]> {
    const network = {
      blockchain: 'eos',
      chainId: config.chainId,
      rpc: config.rpcUrl,
    }
    const connected = await this.provider.connect('Totoro', { network })
    if (!connected) throw new Error('no metahub')
    try {
      this.eos = this.provider.eos(network, Api, { rpc })
      this.accounts = this.provider.identity?.accounts || []
    } catch (e) {
      console.log(e)
    }
    return this.accounts
  }

  async login(): Promise<EosAccount[]> {
    const identity = await this.provider.login()
    if (!identity) return []
    this.accounts = identity.accounts
    return this.accounts
  }

  async logout(): Promise<void> {
    this.accounts = []
    await this.provider.logout()
  }

  async transact(actions: EosAction[]): Promise<TransactionResult> {
    const options = { blocksBehind: 3, expireSeconds: 120 }
    return await this.eos.transact({ actions }, options)
  }
}
